- const { parent } = properties
- const data = parent.data[parent.api].competition
- const {
-   rows,
-   competition,
-   columns,
-   page,
-   perPage,
-   loading,
- } = data

if competition
  table.competitions
    thead
      th
        each column in parent.data[parent.api].competitions.columns
          td: span= parent.columnize(column)
    tbody
      tr
        if parent.api === 'gamescorekeeper'
          td: span= competition.id
          td: span= competition.name
          td: span= competition.sportAlias
          td: span
            if competition.startDate
              = parent.moment(competition.startDate).format(parent.dateFormat)
          td: span
            if competition.endDate
              = parent.moment(competition.endDate).format(parent.dateFormat)

.filters
  .item
    label From
    ft-calendar(
      secondary,
      placeholder='From',
      [(date)]=data.filter.from,
      (dateChanged)=(parent.filterOn('competition', 'from', e.value), parent.loadCompetition())
    )
  .item
    label To
    ft-calendar(
      secondary,
      placeholder='To',
      [(date)]=data.filter.to,
      (dateChanged)=(parent.filterOn('competition', 'to', e.value), parent.loadCompetition())
    )
  .item
    label Status
    ft-select(
      [(value)]=data.filter.status,
      placeholder='Status',
      (change)=(parent.filterOn('competition', 'status', e.value), parent.loadCompetition())
    )
      option(value='') any
      each status in parent.data[parent.api].statuses
        option(value=status)= status
  .item
    ft-button(
      danger,
      (click)=(parent.resetFilter('competition'), parent.loadCompetition())
    ) Reset

if loading
  h2.loading Loading...
else if !loaded && competition
  table.competition
    thead
      th
        each column in columns
          td: span= parent.columnize(column)
    tbody
      each row in rows
        if parent.api === 'gamescorekeeper'
          - const status = row.status?.toLowerCase()
          - const winner = row.participants?.find(p => +p.id === +row.winnerId)
          tr(
            class={cancelled: status === 'cancelled'}
          )
            td.id
              ft-button(href=parent.linkTo({ tab: 'fixture', id: row.id }))
                span= row.id
            td.live-feed(class={ disabled: ['cancelled', 'forfeited'].includes(status) })
              ft-button(href=parent.linkTo({ tab: 'liveFeed', id: row.id }))
                span Feed
            td: span
              if row.scheduledStartTime
                = parent.moment(row.scheduledStartTime).format(parent.dateFormat)
            td: span
              if row.startTime
                = parent.moment(row.startTime).format(parent.dateFormat)
            td: span
              if row.endTime
                = parent.moment(row.endTime).format(parent.dateFormat)
            td
              each participant in row.participants || []
                section
                  each key in Object.keys(participant)
                    span= `${key}: ${parent.displayValue(participant[key])}`
            td
              span= `${row.format.name} ${parent.displayValue(row.format.value)}`
              span= `Tieable?: ${row.format.isMapTieable}`
            td.status(class=status): span= status
            td: span= parent.displayValue(row.tie)
            td
              if row.winnerId
                span= `${row.winnerId} - ${winner?.name}`
              else
                span -

  ft-pagination(
    primary=true,
    display=4,
    current=page,
    (currentChanged)=parent.loadCompetition(e.target.current),
    size=perPage,
    total=9999
  )